import { BLOCK_TYPES as e, DEFAULT_ALIGNMENT as t } from "./constants.js";
import { TextBlockParser as n } from "./text-block-parser.js";
import { require_dist as r } from "./bundled_deps/.pnpm/@intercom_intercom-sanitizer@3.0.0_@braintree_sanitize-url@7.0.2_isomorphic-dompurify@2.34.0_canvas@3.2.0_/bundled_deps/@intercom/intercom-sanitizer/dist/index.js";
import { getResponsiveClasses as i } from "./utils/tables.js";
//#region src/block-parser.ts
var a = r(), o = class {
	schema;
	documentBuilder;
	textBlockParser;
	customBlockHandlers;
	constructor(e, t) {
		this.config = t, this.documentBuilder = e, this.schema = e.schema, this.textBlockParser = new n(e, t), this.customBlockHandlers = /* @__PURE__ */ new Map();
		for (let e of t.customBlockHandlers ?? []) this.customBlockHandlers.set(e.type, e);
	}
	handle(t, n) {
		let r = this.customBlockHandlers.get(t.type);
		if (r) {
			r.parse(t, this);
			return;
		}
		switch (t.type) {
			case e.ORDERED_NESTED_LIST:
			case e.UNORDERED_NESTED_LIST:
				this.nestedList(t);
				break;
			case e.PARAGRAPH:
			case e.ORDERED_LIST:
			case e.UNORDERED_LIST:
			case e.HEADING:
			case e.SUBHEADING:
			case e.SUBHEADING3:
			case e.SUBHEADING4:
			case e.SMALL:
				this.textBlockParser.handle(t, n);
				break;
			case e.CODE:
				this.schema.nodes.codeBlock ? this.textBlockParser.handle(t, n) : this.handleFallback(t);
				break;
			case e.HTML:
				this.html(t);
				break;
			case e.HORIZONTAL_RULE:
				this.horizontalRule(t);
				break;
			case e.IMAGE:
				this.image(t);
				break;
			case e.IMAGE_TEXT:
				this.imageText(t);
				break;
			case e.VIDEO:
				this.video(t);
				break;
			case e.VIDEO_FILE:
				this.videoFile(t);
				break;
			case e.AUDIO_FILE:
				this.audioFile(t);
				break;
			case e.BUTTON:
				this.button(t);
				break;
			case e.MESSENGER_CARD:
				this.messengerCard(t);
				break;
			case e.TABLE:
				this.table(t);
				break;
			case e.IF_ELSE_STATEMENT:
				this.ifElseStatement(t);
				break;
			case e.TWITTER_FOLLOW_BUTTON:
				this.twitterFollowButton(t);
				break;
			case e.FACEBOOK_LIKE_BUTTON:
				this.facebookLikeButton(t);
				break;
			case e.SOCIAL:
				this.social(t);
				break;
			case e.SPACER:
				this.spacer(t);
				break;
			case e.CALLOUT:
				this.callout(t);
				break;
			case e.COLLAPSIBLE_SECTION:
				this.collapsibleSection(t);
				break;
			case e.UNSUPPORTED_ELEMENT:
				this.unsupportedElement(t);
				break;
			default:
				this.handleFallback(t);
				break;
		}
	}
	handleFallback(e) {
		if (this.config.fallbackBlockConfig) {
			let { nodeTypeName: t } = this.config.fallbackBlockConfig, n = this.schema.nodes[t];
			n && (this.documentBuilder.openNode(n, {
				type: t,
				originalType: e.type,
				originalData: e
			}), this.documentBuilder.closeNode());
		}
	}
	table(e) {
		let t = this.schema.nodes.table;
		if (t) {
			let n = {
				responsive: e.responsive || !1,
				container: e.container || !1,
				sectionType: e.sectionType
			};
			typeof e.stacked == "boolean" && (n.stacked = e.stacked);
			let r = this.getPaddingAttrs(e);
			n = {
				...n,
				backgroundColor: this.addBackgroundColor(e) ?? "",
				borderRadius: this.addBorderRadius(e) ?? "",
				...r
			}, this.documentBuilder.openNode(t, n), e.rows.forEach((e) => this.tableRow(e, n)), this.documentBuilder.closeNode();
		} else this.handleFallback(e);
	}
	tableRow(e, t) {
		let n = this.schema.nodes.tableRow;
		if (n) {
			let r = t.responsive ? { responsiveClasses: i(e.cells.length) } : {};
			r = t.container ? {
				...r,
				container: !0
			} : r, this.documentBuilder.openNode(n, {}), e.cells.forEach((e) => this.tableCell(e, r)), this.documentBuilder.closeNode();
		}
	}
	tableCell(e, t) {
		let n = this.schema.nodes.tableCell;
		if (n) {
			if (t.container) {
				let n = this.getPaddingAttrs(e);
				t = {
					...t,
					...n
				};
			}
			!t.container && !t.responsive && (t = {
				...t,
				backgroundColor: this.addBackgroundColor(e) ?? ""
			}), e.displayWidth && (t = {
				...t,
				colwidth: [e.displayWidth]
			}), this.documentBuilder.openNode(n, t), t.container && e.content.length === 0 && this.schema.nodes.placeholder && this.placeholder(), e.content.forEach((e) => this.handle(e)), this.documentBuilder.closeNode();
		}
	}
	social(e) {
		let t = this.schema.nodes.social;
		t ? (this.documentBuilder.openNode(t, {
			alignment: this.alignmentClass(e),
			items: e.items
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	spacer(e) {
		let t = this.schema.nodes.spacer;
		t ? (this.documentBuilder.openNode(t, { height: e.height }), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	callout(e) {
		let t = this.schema.nodes.callout;
		t ? (this.documentBuilder.openNode(t, {
			type: e.type,
			backgroundColor: this.addBackgroundColor(e) ?? "",
			borderColor: this.addBorderColor(e) ?? ""
		}), e.content.forEach((e) => this.handle(e)), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	unsupportedElement(e) {
		let t = this.schema.nodes.unsupportedElement;
		t ? (this.documentBuilder.openNode(t, {
			type: e.type,
			unsupportedTypeName: e.unsupportedTypeName,
			text: e.text
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	placeholder(e = {}) {
		let t = this.schema.nodes.placeholder;
		t && (this.documentBuilder.openNode(t, e), this.documentBuilder.closeNode());
	}
	nestedList(e) {
		let t = this.schema.nodes[e.type];
		t ? (this.documentBuilder.openNode(t, {}), e.items.forEach((e) => this.nestedListItem(e)), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	nestedListItem(e) {
		let t = this.schema.nodes.nestedListItem;
		t && (this.documentBuilder.openNode(t, {}), e.content.forEach((e) => this.handle(e)), this.documentBuilder.closeNode());
	}
	ifElseStatement(e) {
		let t = this.schema.nodes.ifElseStatement;
		t ? (this.documentBuilder.openNode(t, {
			predicatesBlocksPairs: e.predicatesBlocksPairs,
			fallbackBlocks: e.fallbackBlocks
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	twitterFollowButton(e) {
		let t = this.schema.nodes.twitterFollowButton;
		t ? (this.documentBuilder.openNode(t, { username: e.username }), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	facebookLikeButton(e) {
		let t = this.schema.nodes.facebookLikeButton;
		t ? (this.documentBuilder.openNode(t, { url: e.url }), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	image(e) {
		let t = this.schema.nodes.image;
		if (t) {
			let n = e.url, r = {
				src: n && typeof n == "string" && n.trim() !== "" ? n : this.config.images?.failedImageUrl ?? "",
				linkUrl: e.linkUrl,
				text: e.text,
				width: e.width,
				displayWidth: e.displayWidth,
				height: e.height,
				alignment: this.alignmentClass(e)
			};
			this.documentBuilder.openNode(t, r), this.documentBuilder.closeNode();
		} else this.handleFallback(e);
	}
	imageText(e) {
		let t = this.schema.nodes.imageText;
		t ? (this.documentBuilder.openNode(t, {
			imageUrl: e.imageUrl,
			title: "title" in e ? e.title : "",
			text: e.text
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	video(e) {
		let t = this.schema.nodes.video;
		if (t) {
			let n = "videoId" in e ? e.videoId : e.id;
			this.documentBuilder.openNode(t, {
				type: e.type,
				provider: e.provider,
				id: n
			}), this.documentBuilder.closeNode();
		} else this.handleFallback(e);
	}
	videoFile(e) {
		let t = this.schema.nodes.videoFile;
		t ? (this.documentBuilder.openNode(t, {
			type: e.type,
			thumbnailUrl: e.thumbnailUrl,
			url: e.url,
			captions: e.captions
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	audioFile(e) {
		let t = this.schema.nodes.audioFile;
		t ? (this.documentBuilder.openNode(t, {
			type: e.type,
			url: e.url
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	button(e) {
		let t = this.schema.nodes.button, n = this.unescapeExpression(e.text);
		if (t) {
			let r = this.getPaddingAttrs(e);
			this.documentBuilder.openNode(t, {
				type: e.type,
				linkUrl: e.linkUrl,
				buttonStyle: e.buttonStyle || "solid",
				alignment: this.alignmentClass(e),
				fontFamily: this.addFontFamily(e) ?? "",
				fontColor: this.addFontColor(e) ?? "",
				backgroundColor: this.addBackgroundColor(e) ?? "",
				...r,
				borderRadius: this.addBorderRadius(e) ?? "",
				text: n
			}), this.documentBuilder.closeNode();
		} else this.handleFallback(e);
	}
	unescapeExpression(e) {
		let t = document.createElement("div");
		return t.innerHTML = (0, a.sanitizeHtml)(e), t.textContent || "";
	}
	horizontalRule(e) {
		let t = this.schema.nodes.horizontalRule;
		t ? (this.documentBuilder.openNode(t, {
			type: e.type,
			text: e?.text,
			width: e?.width ?? "",
			borderColor: this.addBorderColor(e) ?? "",
			borderWidth: this.addBorderWidth(e) ?? "",
			borderStyle: this.addBorderStyle(e) ?? ""
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	collapsibleSection(e) {
		let t = this.schema.nodes.collapsibleSection;
		if (!t) {
			this.handleFallback(e);
			return;
		}
		this.documentBuilder.openNode(t, {}), this.collapsibleSectionSummary(e), this.collapsibleSectionContent(e), this.documentBuilder.closeNode();
	}
	collapsibleSectionSummary(e) {
		let t = this.schema.nodes.collapsibleSectionSummary;
		t && (this.documentBuilder.openNode(t, {}), this.handle(e.summary), this.documentBuilder.closeNode());
	}
	collapsibleSectionContent(e) {
		let t = this.schema.nodes.collapsibleSectionContent;
		t && (this.documentBuilder.openNode(t, {}), e.content.forEach((e) => this.handle(e)), this.documentBuilder.closeNode());
	}
	html(e) {
		let t = this.schema.nodes.html;
		t ? (this.documentBuilder.openNode(t, { content: e.content }), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	messengerCard(e) {
		let t = this.schema.nodes.messengerCard;
		t ? (this.documentBuilder.openNode(t, {
			canvas: e.canvas,
			text: e.text,
			messenger_app_id: e.messenger_app_id,
			uri: e.uri
		}), this.documentBuilder.closeNode()) : this.handleFallback(e);
	}
	alignmentClass(e) {
		return "align" in e ? e.align : t;
	}
	addFontFamily(e) {
		if ("style" in e) return e.style?.fontFamily;
	}
	addFontColor(e) {
		if ("style" in e) return e.style?.fontColor;
	}
	addBackgroundColor(e) {
		if ("style" in e) return e.style?.backgroundColor;
	}
	addBorderColor(e) {
		if ("style" in e) return e.style?.borderColor;
	}
	addBorderStyle(e) {
		if ("style" in e) return e.style?.borderStyle;
	}
	addBorderWidth(e) {
		if ("style" in e) return e.style?.borderWidth;
	}
	getPaddingAttrs(e) {
		return "style" in e ? {
			paddingTop: e.style?.paddingTop ?? "",
			paddingBottom: e.style?.paddingBottom ?? "",
			paddingLeft: e.style?.paddingLeft ?? "",
			paddingRight: e.style?.paddingRight ?? ""
		} : {};
	}
	addBorderRadius(e) {
		if ("style" in e) return e.style?.borderRadius;
	}
};
//#endregion
export { o as BlockParser };
